// A harvest sheet can hold several sales. This joins their values the same
// way in the form, the Historial and the export.
const distinct = (values) => [...new Set(values.filter((v) => v != null && v !== ''))];

const decimalText = (value) => (value == null ? '' : String(Number(value)).replace('.', ','));

// Cajas on the sheet: `harvest_boxes` (pre-filled from the sale, editable) when present,
// otherwise the sale's own cajas.
const sheetBoxes = (s) => (s.harvest_boxes !== undefined ? s.harvest_boxes : s.boxes);

// Cajas 43 = cajas × peso de caja ÷ 43. The API saves it per sale (boxes_43); the
// form computes it live until the sheet is saved.
const boxes43 = (s) => {
  if (s.boxes_43 != null) return Number(s.boxes_43);
  const boxes = sheetBoxes(s);
  if (boxes == null || s.fruit_weight == null) return null;
  return (boxes * Number(s.fruit_weight)) / 43;
};

// Shown as whole cajas (rounded); the API keeps the exact value.
export const roundBoxes43 = (value) => (value == null ? null : Math.round(value));
export const formatBoxes43 = (value) => (value == null ? '' : roundBoxes43(value).toLocaleString('es-EC'));

// Ratio (total cajas 43lbs ÷ racimos procesados), shown with 2 decimals; the API keeps 6.
export const formatRatio = (value) => (value == null
  ? '—' : Number(value).toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

export function summarizeHarvestSales(sales) {
  return {
    ids: sales.map((s) => s.id),
    company: distinct(sales.map((s) => s.company_name)).join(' / '),
    farm: distinct(sales.map((s) => s.farm_name)).join(' / '),
    exporters: distinct(sales.map((s) => s.exporter_name)).join(' / '),
    brands: distinct(sales.map((s) => s.brand_name)).join(' / '),
    // Cajas and peso de caja stay split per sale (never added up or merged): one row per sale.
    // Labels follow the VENTA 1, VENTA 2… rows on the form.
    boxes: sales.map((s, i) => ({
      label: sales.length > 1 ? `CAJAS VENTA ${i + 1}` : 'CAJAS',
      label43: sales.length > 1 ? `CAJAS (43LBS) VENTA ${i + 1}` : 'CAJAS (43LBS)',
      saleId: s.id,
      value: sheetBoxes(s),
      value43: boxes43(s),
    })),
    fruitWeights: sales.map((s, i) => ({
      label: sales.length > 1 ? `PESO DE CAJA VENTA ${i + 1}` : 'PESO DE CAJA',
      saleId: s.id,
      value: s.fruit_weight == null ? null : Number(s.fruit_weight),
      text: decimalText(s.fruit_weight),
    })),
  };
}
